import { gql } from '@apollo/client';
import NOTIFICATION from '../fragments/NOTIFICATION';
const GET_UNREAD_NOTIFICATIONS = gql `
  query GetMyUnreadNotifications {
    getMyUnreadNotifications {
      ...NotificationNodeFields
    }
  }
  ${NOTIFICATION}
`;
export default GET_UNREAD_NOTIFICATIONS;
